export default __webpack_public_path__ + "static/media/flag-sweden.352c0262.svg";